import React, { Component } from 'react';

import AutoComplete from '../../../../../../components/AutoComplete';
import Button from '../../../../../../components/Button';
import Modal from '../../../../../../components/Modal';
import { IOption } from '../../../../../../components/Select/Select';

export interface ITransferAdminDialogProps {
  nameOptions: IOption[];
  open: boolean;
  toggleOpenDialog: () => void;
  selectOfficer: (value: any) => () => void;
}

interface ITransferAdminDialogState {
  selectedOption: IOption | null;
}

export default class TransferAdminDialog extends Component<
  ITransferAdminDialogProps,
  ITransferAdminDialogState
> {
  constructor(props: ITransferAdminDialogProps) {
    super(props);
    this.state = {
      selectedOption: null
    };
  }

  public render(): JSX.Element {
    const { nameOptions, open, selectOfficer, toggleOpenDialog } = this.props;

    return (
      <Modal
        onClose={toggleOpenDialog}
        open={open}
        className="select-dialog"
        title="Transfer Membership"
        actions={[
          <Button
            key="button-remove-cancel"
            fullWidth={true}
            onClick={toggleOpenDialog}
            className="confirm-removal-button"
            color="primary"
          >
            Cancel
          </Button>,
          <Button
            key="button-remove-ok"
            fullWidth={true}
            onClick={selectOfficer(this.state.selectedOption)}
            variant="contained"
            className="confirm-removal-button"
            color="primary"
            disabled={!this.state.selectedOption}
          >
            OK
          </Button>
        ]}
      >
        <AutoComplete
          className="relativeMenu"
          onChange={(option: any) => {
            this.setState({ selectedOption: option });
          }}
          options={nameOptions}
        />
      </Modal>
    );
  }
}
